import { send } from '@emailjs/browser';

export const sendEmail = async (subject: string, emailTemplate: any, email?: string) => {
	const emailInfo = {
		receiver_email: email ? email : 'admin@tarcalumni.my',
		title: subject,
		message: emailTemplate,
	};

	await send('service_8m52zgp', 'template_c6huabp', emailInfo, 'X330-n5Z1PGk13XpH');
};
